<template>
	<div class="wrap">
		<div class="banner">
			<el-carousel height="500px">
				<el-carousel-item v-for="(item, index) in bannerList" :key="index">
					<el-image :src="item.img" fit="fill" @click="jumpUrl(item)"></el-image>
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="content">
<!--			<div style="padding: 0 340px 39px 340px; background-color: white;">-->
<!--				<div class="moduleHeader" style="margin-bottom: 45px;">-->
<!--					<div class="moduleTab">-->
<!--						<div :class="['moduleTab', videoTabKey === '1' ? 'moduleActive' : '']" @click="selectModuleTab('video', '1')">-->
<!--							<div>主管护师试听课</div>-->
<!--							<div class="moduleTabLine" v-show="videoTabKey === '1'"></div>-->
<!--						</div>-->
<!--						<div :class="['moduleTab', videoTabKey === '2' ? 'moduleActive' : '']" @click="selectModuleTab('video', '2')">-->
<!--							<div>护师试听课</div>-->
<!--							<div class="moduleTabLine" v-show="videoTabKey === '2'"></div>-->
<!--						</div>-->
<!--						<div :class="['moduleTab', videoTabKey === '3' ? 'moduleActive' : '']" @click="selectModuleTab('video', '3')">-->
<!--							<div>护考试听课</div>-->
<!--							<div class="moduleTabLine" v-show="videoTabKey === '3'"></div>-->
<!--						</div>-->
<!--					</div>-->
<!--					&lt;!&ndash; <div class="moduleMore">查看更多>></div> &ndash;&gt;-->
<!--				</div>-->
<!--				<div class="videoPlayerBox">-->
<!--					<div>-->
<!--						<div class="videoPlayer"></div>-->
<!--						<div class="videoName">-->
<!--							<div>{{ videoLive.class_name }}</div>-->
<!--						</div>-->
<!--					</div>-->
<!--					<div class="video-region">-->
<!--						<div v-for="pkg in videoPackageList" class="pkg-region" :key="pkg.video_package_id" :name="pkg.video_package_id" @click="videoPackageChange(pkg.video_package_id)">-->
<!--							<div class="pkg-title-region">-->
<!--								<div>{{ pkg.package_name }}</div>-->
<!--								<div v-if="videoLive.package_id === pkg.video_package_id">-->
<!--									<i class="el-icon-arrow-down"></i>-->
<!--								</div>-->
<!--								<div v-else><i class="el-icon-arrow-up"></i></div>-->
<!--							</div>-->
<!--							<div class="class-region" v-show="videoLive.package_id === pkg.video_package_id">-->
<!--								<div-->
<!--									v-for="clazz in pkg.video_class_list"-->
<!--									:key="clazz.video_class_id"-->
<!--									@click="changeVideo(clazz)"-->
<!--									:class="{-->
<!--										'live-video': clazz.play_url_360 === videoLive.vid,-->
<!--									}"-->
<!--									class="class-title"-->
<!--								>-->
<!--									{{ clazz.class_name }}-->
<!--								</div>-->
<!--							</div>-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->
			<div style="padding: 30px 280px 0 280px;">
				<div class="moduleHeader" style="margin-bottom: 36px; padding: 0 60px;">
					<div class="moduleTab">
						<div :class="['moduleTab', majorTabKey === '111' ? 'moduleActive' : '']" @click="selectModuleTab('major', '111')">
							<div>主管护师</div>
							<div class="moduleTabLine" v-show="majorTabKey === '111'"></div>
						</div>
						<div :class="['moduleTab', majorTabKey === '121' ? 'moduleActive' : '']" @click="selectModuleTab('major', '121')">
							<div>初级护师</div>
							<div class="moduleTabLine" v-show="majorTabKey === '121'"></div>
						</div>
						<div :class="['moduleTab', majorTabKey === '131' ? 'moduleActive' : '']" @click="selectModuleTab('major', '131')">
							<div>护考</div>
							<div class="moduleTabLine" v-show="majorTabKey === '131'"></div>
						</div>
					</div>
					<!-- <div class="moduleMore">查看更多>></div> -->
					<div class="classTab">
						<div :class="['classTabItem', classTabKey === '20' ? 'classTabItem_active' : '']" @click="selectModuleTab('class', '20')">
							课程套餐
						</div>
						<div :class="['classTabItem', classTabKey === '10' ? 'classTabItem_active' : '']" @click="selectModuleTab('class', '10')">
							图书
						</div>
						<div class="classTabSwitch" ref="classTabSwitch"></div>
					</div>
				</div>

				<div class="classList">
					<el-carousel height="350px" :autoplay="false" arrow="always" indicator-position="none">
						<el-carousel-item v-for="(item, index) in classList" :key="index">
							<div style="width: 100%; height: 100%; display: flex; justify-content: space-around; box-sizing: border-box; padding: 0 60px;">
								<div v-for="(classItem, classIndex) in item.children" :key="classIndex" @click="jumpOpenUrl(classItem.sale_url)" class="classItem">
									<div class="classImage" style="width: 220px; height: 220px; border-radius: 15px; overflow: hidden; margin-bottom: 10px;">
										<el-image style="width: 220px; height: 220px;" :src="classItem.img_url" fit="fill"></el-image>
									</div>
									<div style="font-size: 18px; color: #424242; width: 220px; line-height: 20px; height: 40px;">
										{{ classItem.web_goods_name }}
									</div>
									<div style="display: flex; align-items: baseline;">
										<div class="classPrice">￥{{ classItem.price_line }}</div>
										<div class="classPrice origin">￥{{ classItem.price }}</div>
									</div>
								</div>
								<div v-for="(classItem, classIndex) in 5 - item.children.length" :key="classIndex" @click="jumpOpenUrl(classItem.sale_url)">
									<div style="width: 256px; height: 256px; border-radius: 15px; overflow: hidden;">
										<!-- <el-image style="width: 256px; height: 256px;" src="" fit="fill"></el-image> -->
									</div>
									<div></div>
									<div style="display: flex; align-items: center;">
										<div class="classPrice"></div>
										<div class="classPrice origin"></div>
									</div>
								</div>
							</div>
						</el-carousel-item>
					</el-carousel>
				</div>
			</div>
			<div style="padding: 38px 0; background-color: white; margin-top: 27px; max-width: 1902px; overflow: hidden;">
				<div class="barrageTitle" style="padding: 0 340px;">
					学员评价
					<div style="width: 250px; height: 1px; background-color: rgb(219, 219, 219);"></div>
				</div>
				<div class="barrageList">
					<div
						class="road"
						v-for="(key, keyIndex) in Object.keys(barrageList)"
						:key="keyIndex"
						:style="{
							animationDuration: `${getRandomInt(barrageList[key].length * 2.5 - 5, barrageList[key].length * 2.5 + 5)}s`,
						}"
					>
						<div class="barrage" v-for="(item, index) in barrageList[key]" :key="index" :style="{ marginRight: `${getRandomInt(100, 120)}px` }">
							<el-popover placement="top" width="310" trigger="hover">
								<div style="text-align: center;">
									<div>{{ item.comment }}</div>
								</div>
								<div slot="reference" class="barrageText">
									{{ item.comment }}
								</div>
							</el-popover>
						</div>
					</div>
				</div>
			</div>
			<div style="padding: 35px 280px 0 280px">
				<div class="barrageTitle" style="padding: 0 60px">
					企业资质与荣誉
					<div style="width: 250px; height: 1px; background-color: rgb(219, 219, 219);"></div>
				</div>
				<div class="photoBox">
					<el-carousel height="280px" :autoplay="false" arrow="always" indicator-position="none">
						<el-carousel-item v-for="(item, index) in 1" :key="index">
							<div class="photoList" style="padding: 0 60px">
								<div class="photoItem" v-for="(item, index) in photoList" :key="index">
									<el-image :src="item" fit="fill"></el-image>
								</div>
							</div>
						</el-carousel-item>
					</el-carousel>
				</div>
			</div>
			<div style="background-color: white; padding: 35px 340px 0 340px; overflow: hidden;">
				<div class="barrageTitle" v-show="aboutBoxShow">
					了解丁震医学教育
					<div style="width: 250px; height: 1px; background-color: rgb(219, 219, 219);"></div>
				</div>
				<div class="aboutBox" ref="aboutBoxRef" v-show="aboutBoxShow">
					<div class="animated animate__bounceInLeft aboutImg"></div>
					<div class="animated animate__bounceInRight aboutText">
						<div style="text-indent: 4ch; margin-bottom: 8px;">
							丁震医学教育（北京丁丁颐和科技有限公司，广州丁丁舜思教育科技有限公司，北京丁丁颐和科技有限公司沈阳分公司www.dzyxedu.com）是专业化的医学考试图书策划及教育培训机构，是医学考试培训领域具有较高知名度的教育品牌。
						</div>
						<div style="text-indent: 4ch; margin-bottom: 8px;">
							创始人丁震老师是国内少有的既懂出版又能讲护理考试课的跨界型专家，原人民军医出版社考试中心主任，曾是风靡全国的“军医版”医学考试书籍的策划人和编著者。从事医学考试图书策划近20年，对考试命题方向和细节把握精准，原创“点线学习法”培训体系，并在全国护理院校进行广泛的推广和应用。
						</div>
						<div style="text-indent: 4ch; margin-bottom: 8px;">
							“丁震医学教育”品牌护理考试图书代表作有《丁震急救包》系列、《丁震654套卷全解析》系列和《丁震单科考点背诵及强化1000题》系列等，培训课程代表作有“全程精修班”“无忧畅听班”等，命中率高，考生口碑好，助力数千万考生通过考试。
						</div>
						<div style="text-indent: 4ch;">
							丁震医学教育团队始终坚持及时修订和内容原创的原则，不断努力，为医考生提供更多精品复习资料。
						</div>
						<div></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import 'animate.css';
	import { apiGetOpenPackageList, apiGetOpenClassList, apiGetStudentComment, apiGetGoodsList } from '@/api/api';
	import Cookies from 'js-cookie';
	const TokenKey = 'Admin-Token';
	export default {
		name: 'Index',
		data() {
			return {
				bannerList: [
					{
						img: 'https://test.dzyxedu.com/homeImage/banner1.png',
						path: '/brandStory',
						type: '1',
					},
					{ img: 'https://test.dzyxedu.com/homeImage/banner2.png' },
					{
						img: 'https://test.dzyxedu.com/homeImage/banner3.png',
						path: 'https://dzyxjy.tmall.com/category-1608766121.htm',
						type: '2',
					},
					{
						img: 'https://test.dzyxedu.com/homeImage/banner4.png',
						path: 'https://dzyxjy.tmall.com/category-1608766121.htm',
						type: '2',
					},
					{
						img: 'https://test.dzyxedu.com/homeImage/banner5.png',
						path: 'https://dzyxjy.tmall.com/category-1506545859.htm',
						type: '2',
					},
				],
				videoTabKey: '1',
				majorTabKey: '111',
				classTabKey: '20',
				classList: [],
				barrageList: [],
				photoList: [
					'https://test.dzyxedu.com/homeImage/%E8%8D%A3%E8%AA%891.png',
					'https://test.dzyxedu.com/homeImage/%E8%8D%A3%E8%AA%892.png',
					'https://test.dzyxedu.com/homeImage/%E8%8D%A3%E8%AA%893.png',
					'https://test.dzyxedu.com/homeImage/%E8%8D%A3%E8%AA%894.png',
				],
				videoPackageList: [],
				videoLive: {
					class_name: '',
					vid: '',
					package_id: '',
				},
				currentScroll: 0,
				aboutBoxShow: true,
			};
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll);
			apiGetOpenPackageList(43)
				.then(res => {
					this.videoPackageList = res.data.map(e => {
						e.video_class_list = [];
						return e;
					});
					this.videoLive.package_id = res.data[0].video_package_id;
					return apiGetOpenClassList(this.videoLive.package_id);
				})
				.then(res => {
					this.videoPackageList[0].video_class_list = res.data;
					this.videoLive.vid = res.data[0].play_url_360;
					this.videoLive.class_name = res.data[0].class_name;
					if (window.ccH5PlayerJsLoaded) {
						this.createList();
					}
				});
			apiGetStudentComment().then(res => {
				const studentComments = res.data.reduce((result, item) => {
					if (result[item.listn]) {
						result[item.listn].push(item);
					} else {
						result[item.listn] = [];
						result[item.listn].push(item);
					}
					return result;
				}, {});
				this.barrageList = studentComments;
			});
			apiGetGoodsList(this.majorTabKey, this.classTabKey).then(res => {
				if (res.code === 200) {
					let result = [];
					for (let i = 0; i < res.data.length; i += 5) {
						result.push(res.data.slice(i, i + 5));
					}
					this.classList = result.map((item, index) => {
						return {
							key: index + 1,
							children: item,
						};
					});
				}
			});
		},
		methods: {
			handleScroll() {
				this.currentScroll = window.scrollY; //表示当前滚动的位置
				if (this.currentScroll > 1000) {
					this.aboutBoxShow = true;
				}
			},
			getRandomInt(min, max) {
				min = Math.ceil(min);
				max = Math.floor(max);
				return Math.floor(Math.random() * (max - min + 1)) + min;
			},
			createList() {
				this.player && this.player.destroy();
				const elems = document.getElementsByClassName('videoPlayer');
				const vid = this.videoLive.vid;
				this.players = window.createCCH5Player({
					vid,
					siteid: '3627C1590A018D15',
					autoStart: true,
					width: '100%',
					height: '422px',
					realAutoPlay: true,
					parentNode: elems[0],
				});
			},
			selectModuleTab(type, key) {
				if (type === 'video') {
					this.videoTabKey = key;
					let mtt;
					if (key === '1') {
						mtt = 43;
					} else if (key === '2') {
						mtt = 42;
					} else if (key === '3') {
						mtt = 41;
					}
					apiGetOpenPackageList(mtt)
						.then(res => {
							this.videoPackageList = res.data.map(e => {
								e.video_class_list = [];
								return e;
							});
							this.videoLive.package_id = res.data[0].video_package_id;
							return this.videoLive.package_id;
						})
						.then(activeVideoPackageId => {
							return apiGetOpenClassList(activeVideoPackageId);
						})
						.then(res => {
							this.videoPackageList[0].video_class_list = res.data;
							this.videoLive.vid = res.data[0].play_url_360;
							this.videoLive.class_name = res.data[0].class_name;
							this.players.changeVideo(this.videoLive.vid);
						});
				}
				if (type === 'major') {
					this.majorTabKey = key;
					apiGetGoodsList(key, this.classTabKey).then(res => {
						if (res.code === 200) {
							let result = [];
							for (let i = 0; i < res.data.length; i += 5) {
								result.push(res.data.slice(i, i + 5));
							}
							this.classList = result.map((item, index) => {
								return {
									key: index + 1,
									children: item,
								};
							});
						}
					});
				}
				if (type === 'class') {
					this.classTabKey = key;
					this.$refs.classTabSwitch.style.left = key !== '10' ? '5px' : '137px';
					apiGetGoodsList(this.majorTabKey, key).then(res => {
						if (res.code === 200) {
							let result = [];
							for (let i = 0; i < res.data.length; i += 5) {
								result.push(res.data.slice(i, i + 5));
							}
							this.classList = result.map((item, index) => {
								return {
									key: index + 1,
									children: item,
								};
							});
						}
					});
				}
			},
			videoPackageChange(video_package_id) {
				this.videoLive.package_id = video_package_id;
				this.videoPackageList.forEach(p => {
					if (p.video_package_id === video_package_id && p.video_class_list.length === 0) {
						apiGetOpenClassList(video_package_id).then(res => {
							p.video_class_list = res.data;
						});
					}
				});
			},
			changeVideo(clazz) {
				this.videoLive.vid = clazz.play_url_360;
				this.videoLive.class_name = clazz.class_name;
				this.players.changeVideo(this.videoLive.vid);
			},
			jumpOpenUrl(url) {
				window.open(url);
			},
			jumpUrl(item) {
				if (item.path) {
					if (item.type === '1') {
						// this.$router.push(item.path);
						this.$emit('changeHeaderTab', item.path);
					}
					if (item.type === '2') {
						this.jumpOpenUrl(item.path);
					}
				}
			},
		},

		beforeDestroy() {
			if (this.players) {
				this.players.destroy();
			}
		},
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	@keyframes moveLeft {
		0% {
			transform: translateX(12%);
		}
		100% {
			transform: translateX(-100%);
		}
	}
	.wrap {
		margin: 0 auto;
		max-width: 1920px;
	}
	.content {
		/* padding: 0 340px; */
	}

	.moduleHeader {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-top: 38px;
	}

	.moduleTab {
		display: flex;
		align-items: baseline;
		font-size: 20px;
		color: #a3a3a3;
		margin-right: 61px;
		position: relative;
		cursor: pointer;
	}

	.moduleTab:hover {
		color: #424242;
	}

	.moduleTab.moduleActive {
		font-size: 24px;
		color: #424242;
	}

	.moduleTabLine {
		position: absolute;
		left: 50%;
		bottom: -8px;
		transform: translateX(-50%);
		width: 50%;
		height: 4px;
		background-color: rgba(255, 158, 116, 1);
	}

	.moduleMore {
		font-size: 24px;
		color: #a3a3a3;
		cursor: pointer;
	}

	.videoPlayerBox {
		display: flex;
		justify-content: space-between;
	}
	.videoPlayer {
		width: 755px;
		border-radius: 25px;
		overflow: hidden;
		/* background-image: url('https://test.dzyxedu.com/homeImage/classStartImage.jpg'); */
		background-position: -86px center;
		background-size: cover;
		margin-bottom: 26px;
	}
	.videoName {
		display: flex;
		align-items: baseline;
		height: 35px;
		font-size: 24px;
		font-weight: 500;
		letter-spacing: 0px;
		line-height: 34.75px;
		color: rgba(43, 46, 51, 1);
		text-align: left;
		vertical-align: top;
	}
	.video-region {
		padding-left: 20px;
	}
	.pkg-region {
		margin: 10px 0;
	}
	.pkg-title-region {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 395px;
		height: 40px;
		border-radius: 5px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
		font-size: 20px;
		padding: 0 14px;
		color: #424242;
		cursor: pointer;
	}
	.class-region {
		margin: 5px 0;
		cursor: pointer;
	}
	.class-title {
		padding: 5px 5px 5px 25px;
		width: 368px;
		min-height: 22px;
		font-size: 15px;
		font-weight: 400;
		letter-spacing: 0px;
		line-height: 21.72px;
		text-align: left;
		vertical-align: top;
	}
	.class-title:hover {
		color: #ff9d73;
	}
	.live-video {
		color: rgba(245, 94, 48, 1);
	}
	.classTab {
		display: flex;
		align-items: center;
		justify-content: space-around;
		position: relative;
		width: 284px;
		height: 39px;
		opacity: 1;
		border-radius: 118px;
		background: rgba(237, 237, 237, 1);
	}
	.classTabItem {
		font-size: 20px;
		color: #666666;
		width: 50%;
		text-align: center;
		position: relative;
		z-index: 10;
		cursor: pointer;
	}
	.classTabItem:hover {
		color: #ff9d73;
		transform: scale(1.1);
	}
	.classTabItem.classTabItem_active {
		color: #fff;
	}
	.classTabSwitch {
		position: absolute;
		z-index: 5;
		left: 5px;
		transition: all linear 0.2s;
		width: 142px;
		height: 32.5px;
		opacity: 1;
		border-radius: 118px;
		background: rgba(245, 94, 48, 1);
	}
	.classItem {
		padding: 10px;
	}
	.classItem .classImage {
		transition: all linear 0.3s;
	}
	.classItem:hover .classImage {
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.9);
		border-radius: 15px;
	}
	.classPrice {
		font-size: 24px;
		font-weight: 500;
		letter-spacing: 0px;
		line-height: 43.44px;
		color: rgba(245, 94, 48, 1);
		text-align: left;
		vertical-align: top;
	}
	.classPrice.origin {
		font-size: 12px;
		font-weight: 400;
		letter-spacing: 0px;
		line-height: 23.17px;
		color: rgba(201, 201, 201, 1);
		text-align: left;
		vertical-align: top;
		text-decoration: line-through;
	}
	.barrageTitle {
		font-size: 24px;
		font-weight: 400;
		letter-spacing: 0px;
		line-height: 34.75px;
		color: rgba(66, 66, 66, 1);
		text-align: left;
		vertical-align: top;
		margin-bottom: 38px;
	}
	.barrageList {
		position: relative;
		/* overflow: hidden; */
		margin-bottom: 40px;
		/* background-image: url("../../assets/学员评价背景图.png");
  background-size: auto;
  background-position: center;
  background-repeat: no-repeat; */
	}
	.road {
		width: fit-content;
		display: flex;
		align-items: center;
		animation-name: moveLeft;
		animation-timing-function: linear;
		animation-iteration-count: infinite;
		animation-play-state: running;
		margin-bottom: 10px;
	}
	.barrage {
		font-size: 20px;
		font-weight: 400;
		letter-spacing: 0px;
		line-height: 37.65px;
		color: rgba(66, 66, 66, 1);
		vertical-align: middle;
		display: flex;
		align-items: center;
		justify-content: center;
		width: fit-content;
		height: 40px;
		opacity: 1;
		border-radius: 40px;
		padding: 0 20px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
	}
	.road:hover {
		animation-play-state: paused; /* 鼠标悬停时暂停动画 */
	}
	.barrageText {
		width: 480px;
		height: 80px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		line-height: 80px;
		text-align: center;
	}
	.photoList {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.photoItem {
		/* width: 269.21px; */
		/* height: 360px; */
		opacity: 1;
		border-radius: 15px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.photoItem div {
		transition: all linear 0.3s;
	}

	.photoItem div:hover {
		transform: scale(1.1);
	}

	.aboutBox {
		display: flex;
		padding-bottom: 56px;
		align-items: center;
	}
	.aboutImg {
		opacity: 1;
		border-radius: 15px;
		background: url('https://test.dzyxedu.com/homeImage/image1.png');
		background-position: center;
		background-size: 120%;
		left: 340px;
		width: 675px;
		height: 360px;
		opacity: 1;
		border-radius: 15px;
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
		margin-right: 41px;
	}
	.aboutText {
		width: 620px;
		opacity: 1;
		/** 文本1 */
		font-size: 16px;
		font-weight: 400;
		letter-spacing: 1px;
		line-height: 23.17px;
		color: rgba(66, 66, 66, 1);
		text-align: justify;
		vertical-align: top;
	}

	& /deep/ .el-carousel__button {
		left: 930px;
		top: 1805px;
		width: 60px;
		height: 10px;
		opacity: 1;
		border-radius: 5px;
		background: rgba(255, 158, 116, 1);
	}
	& /deep/ .el-carousel__item.is-animating {
		transition: transform 2s ease-in-out, -webkit-transform 2s ease-in-out;
	}

	/deep/ .el-carousel__indicator--horizontal .el-carousel__button {
		width: 60px;
		height: 10px;
		opacity: 1;
		border-radius: 5px;
		background: rgba(222, 222, 222, 1);
	}

	/deep/ .el-carousel__indicator--horizontal.is-active .el-carousel__button {
		background: rgba(255, 255, 255, 1) !important;
	}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue